// extracted by mini-css-extract-plugin
export default {"parent":"tabPanel_parent__VsiAo","parentDot":"tabPanel_parentDot__aKyca"};